<template>
  <div class="chatSidebar">
    <!-- 最左侧区域-->
    <div class="aside dark-1">
      <!-- LOGO-->
      <el-tooltip
          popper-class="aside-tooltip"
          effect="dark"
          content="AlongShare"
          placement="right">
        <div class="aside-logo" @click="goHome">
          <img :src="`${$g.imgPrefix}/img/shareAI/ai-logo.png`" class="aside-logo-img" alt="">
        </div>
      </el-tooltip>
      <div class="aside-line"></div>
      <div class="aside-list">
        <el-tooltip
            popper-class="aside-tooltip"
            effect="dark"
            v-for="(aItem,aIndex) in asideList"
            :key="aIndex"
            :content="aItem.text"
            placement="right">
          <div class="aside-btn">
            <img :src="aItem.imgSrc" class="aside-btn-img">
            <div v-show="aItem.showVerticalBar" class="aside-btn-vbar"></div>
          </div>
        </el-tooltip>
      </div>
    </div>
    <!-- 操作区域-->
    <div class="operate dark-2">
      <div class="operate-header">
        <div class="operate-title light-color-1">AI Chat</div>
        <i v-if="screenWidth<=798" class="el-icon-close" @click="closeSideBar"></i>
      </div>

      <!-- 新建会话-->
      <div class="create">
        <div class="create-btn purple" @click="createNewSession">
          <div class="create-content white">
            New Chat
<!--            <img :src="`${$g.imgPrefix}/img/shareAI/deepseek-icon.webp`">-->
<!--            <div class="create-content-text white">New chat</div>-->
          </div>
        </div>
      </div>

      <!-- 会话列表-->
      <div class="list">
        <!-- 置顶会话-->
        <toppingChat ref="toppingChat" title="Topping" :chatList="toppingList" @list-delete-session="deleteSession" @list-select-session="selectSession">
          <!-- 取消置顶-->
          <template #cancelTopping="{ data,sIndex }">
            <img @click.stop="handleTopData(data,sIndex)" :src="`${$g.imgPrefix}/img/shareAI/no-topping-light.svg`" class="top-icon cancel-top">
          </template>
        </toppingChat>


        <!-- 今天会话-->
        <todayChat ref="todayChat" title="Today" :chatList="todayList" @list-delete-session="deleteSession" @list-select-session="selectSession">
          <!-- 置顶-->
          <template #onTopping="{ data,sIndex }">
            <img @click.stop="handleTopData(data,sIndex)" :src="`${$g.imgPrefix}/img/shareAI/topping-light.svg`" class="top-icon">
          </template>
        </todayChat>


        <!-- 最近会话-->
        <recentChat ref="recentChat" title="Recent" :chatList="recentList" @list-delete-session="deleteSession" @list-select-session="selectSession">
          <!-- 置顶-->
          <template #onTopping="{ data,sIndex }">
            <img @click.stop="handleTopData(data,sIndex)" :src="`${$g.imgPrefix}/img/shareAI/topping-light.svg`" class="top-icon">
          </template>
        </recentChat>
      </div>

      <!-- footer-->
      <div class="footer">
        <!-- Your Plan-->
        <div v-if="screenWidth>576" class="plan dark-4">
          <div class="plan-title white">Your Plan</div>
          <div class="info">
            <!-- Free quota：-->
            <div class="info-item">
              <div class="info-item-label light-color-3">Free quota：</div>
              <div class="info-item-count white">
                <span class="info-item-value before">{{ quotaData.usedFreeCount }}</span>
                /
                <span class="info-item-value">{{ quotaData.freeTokenLimit }}</span>
              </div>
            </div>
            <!-- Paid quota：-->
            <div class="info-item">
              <div class="info-item-label light-color-3">Paid quota：</div>
              <div class="info-item-paid-count white">
                <span>{{ quotaData.paidQuota }}</span>
<!--                <el-tooltip popper-class="paid-popper" effect="dark" placement="top">-->
<!--                  <div slot="content" class="content">-->
<!--                    <div class="list">-->
<!--                      <div class="item">-->
<!--                        <div class="label">Subscription quotas</div>-->
<!--                        <div class="count">{{ quotaData.subscription }}</div>-->
<!--                      </div>-->
<!--                      <div class="item">-->
<!--                        <div class="label">Extra quotas</div>-->
<!--                        <div class="count">{{ quotaData.extra }}</div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <i class="el-icon-warning"></i>-->
<!--                </el-tooltip>-->
              </div>
            </div>
            <!-- Buy now-->
            <div class="info-buy">
              <div class="info-buy-text" @click="toBuyNow">Buy now</div>
            </div>
            <!-- Quota usage introduction -->
            <el-popover
                :append-to-body="false"
                placement="right-end"
                popper-class="intro-popper"
                width="400"
                trigger="click">
               <div class="list">
                 <div class="list-item" v-for="(listItem,listIndex) in models" :key="listIndex">
                   {{ `${listItem.modelName} consumes ${listItem.tokenCost} quota each time` }}
                 </div>
               </div>
              <div slot="reference" class="info-introduction light-color-3">Quota usage introduction</div>
            </el-popover>
          </div>
        </div>
        <!-- 用户账号，头像-->
        <div class="user dark-4">
          <div class="user-avatar">
            <img :src="`${$g.imgPrefix}/img/home/avatar.svg`">
            <!-- 是否在线-->
            <div class="dot green"></div>
          </div>
          <div class="user-info white">
            <div class="user-info-name">{{ userinfo.email }}</div>
            <div class="user-info-online">online</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//置顶会话
import toppingChat from './chatSideList';
//今天的会话
import todayChat from "./chatSideList";
//最近的会话
import recentChat from "./chatSideList";
import {
  isEmpty,
  formatObj,
  checkIfToday
} from '@/util/util'
import {
  getUserActiveSubscription
} from "@/request/requests";
export default {
  name: "aiSideBar",
  components:{
    toppingChat,
    todayChat,
    recentChat
  },
  props: {
    showDrawerSide:Boolean,
    isDark: Boolean,
    models: {
      type: Array,
      default: () => []
    },
    selectedModel: {
      type: String,
      default: ''
    },
    screenWidth:Number,
    userinfo:{
      type:Object,
      default:()=>{
        return {}
      }
    },
  },
  watch:{
    sessions:{
      handler(newVal){
        this.setList(newVal);
      },
      immediate:true
    }
  },
  computed:{
    sessions:{
      get(){
        return this.$store.state.chat.sessions;
      },
      set(val) {
        this.$store.commit('chat/SET_SESSION', val);
      }
    },
    quotaData:{
      get(){
        return this.$store.state.chat.quotaData;
      },
      set(val) {
        this.$store.commit('chat/SET_QUOTA_DATA', val);
      }
    }
  },
  data(){
    return{
      asideList:[
        {
          // text: 'ChatGPT & DeepSeek',
          text: 'AI Chat',
          imgSrc: `${this.$g.imgPrefix}/img/shareAI/model-logo.png`,
          //是否显示竖条
          showVerticalBar: false
        }
      ],
      // quotaData:{
      //   //已使用的免费额度 = 免费额度 - 已使用的免费额度
      //   usedFreeCount:0,
      //   //免费额度
      //   freeTokenLimit:0,
      //   //付费额度
      //   paidQuota:0,
      //   //--------暂时没有--------
      //   subscription:0,
      //   extra:0
      // },
      sessionList:[],
      //今天的消息
      todayList:[],
      //最近的消息
      recentList:[],
      //置顶的消息
      toppingList:[],
    }
  },
  methods: {
    isEmpty,
    formatObj,
    checkIfToday,
    setList(sessions){
      this.sessionList = this.formatObj(sessions);
      //今天的消息
      this.todayList = [],
      //最近的消息
      this.recentList = [];
      //置顶的消息
      this.toppingList = [];
      if(!this.isEmpty(this.sessionList)){
        this.sessionList.forEach(item=>{
          //置顶的消息 topFlag:0不置顶 1置顶
          if(item.topFlag=='1'){
            this.toppingList.push(item);
          }else{
            //未置顶的消息  今天、最近消息
            //今天的消息
            if(this.checkIfToday(item.updatedAt)) {
              this.$set(item, 'isTodayFlag', true);
              this.todayList.push(item);
            }else{
              //最近的消息
              this.$set(item,'isTodayFlag',false);
              this.recentList.push(item);
            }
          }
        })
      }
    },
    async getSubscription(){
      let res = await getUserActiveSubscription();
      if(res.status == '200'){
        let data = res.data;
        if(!this.isEmpty(data)){
          //免费额度
          this.$set(this.quotaData,'freeTokenLimit',data.freeTokenLimit);
          //已使用的免费额度 = 免费额度 - 已使用的免费额度
          this.$set(this.quotaData,'usedFreeCount',data.freeTokenLimit - data.usedFreeCount);
          //付费额度
          this.$set(this.quotaData,'paidQuota',data.paidQuota);

        }
      }
    },
    closeSideBar(){
      this.$emit('closeSideBar');
    },
    toBuyNow(){
      this.$emit('initBuyNowPC')
    },
    handleTopData(data,sIndex){
      this.$emit('top-or-cancel',data,sIndex);
    },
    goHome(){
      if (this.screenWidth > 576.98) {
        this.$router.push({name: 'home'})
      } else {
        this.$router.push({name: 'phonehome'})
      }
    },
    createNewSession() {
      this.$emit('create-new-session');
    },
    selectSession(conversationId) {
      this.$emit('select-session', conversationId);
    },
    deleteSession(conversationId) {
      this.$emit('delete-session', conversationId);
    },
    onModelChange(event){
      this.$emit('change-model', event.target.value);
    },
    calcWidth() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.$forceUpdate();
    },
  },
  mounted(){
    this.getSubscription();
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/shareAI.scss";
</style>
<style lang="scss">
.el-tooltip__popper.is-dark.aside-tooltip{
  background: #232428;
  line-height: 2.2;
  font-size:15px;
}

.paid-popper{
  border: 1px solid #383940;
  width:160px;
  .popper__arrow{
    display:none;
  }
  .content{
    .item{
      display:flex;
      align-items: baseline;
      margin-bottom:10px;
      font-size:13px!important;
    }
    .count{
      margin-left:5px;
      font-weight:bold;
      font-family: Gilroy, FB;
    }
  }
}

.intro-popper{
  border: 1px solid #383940;
  border-radius: 8px;
  background: #232428;
  .popper__arrow{
    display:none;
  }
  .list{
    &-item{
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      color:#b5bac1;
      font-family: Gilroy, FB;
      &:not(:last-child){
        margin-bottom: 10px;
      }

    }
  }
}
</style>